/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Out_Order_EmptyInputs */

const vi_pkl_out_order_empty = /** @type {(inputs: Pkl_Out_Order_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có đơn phù hợp`)
};

/**

* @param {Pkl_Out_Order_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_out_order_empty = /** @type {((inputs?: Pkl_Out_Order_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Out_Order_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_out_order_empty(inputs)
});